import { jsx as t, jsxs as B } from "react/jsx-runtime";
import { useState as e, useEffect as S } from "react";
import { getCoupons as E } from "./api/getCoupons.js";
import { LoadingView as G } from "./views/LoadingView.js";
import { CouponsView as H } from "./views/CouponsView.js";
import { RulesView as K } from "./views/RulesView.js";
import { OverwriteView as P } from "./views/OverwriteView.js";
import { EmptyCartView as Q } from "./views/EmptyCartView.js";
/* empty css                    */const I = ({
  orderFormId: h,
  hasItemsInCart: i,
  builder: j,
  account: a,
  isIO: o = !1,
  closeIOModal: r,
  activeOrderFormCoupon: n,
  genericTaggingEvent: s,
  disableFirstEmptyModal: A,
  couponsList: f,
  qtdCouponsView: l
}) => {
  const [L, w] = e(!0), [q, p] = e([]), [u, c] = e("coupons-view"), [D, C] = e(!1), [y, N] = e(!1), [d, v] = e(""), [m, R] = e(""), [J, V] = e(
    !A
  ), [b, k] = e();
  return S(() => {
    n && v(n);
  }, [n]), S(() => {
    (async () => {
      w(!0);
      try {
        const x = await E(a, j, f);
        if (l) {
          const z = x.slice(0, l);
          p(z);
          return;
        }
        p(x);
        return;
      } catch {
        p([]);
      } finally {
        w(!1);
      }
    })();
  }, [JSON.stringify(f)]), L ? /* @__PURE__ */ t("div", { className: "coupons-container", children: /* @__PURE__ */ t(
    G,
    {
      isIO: o,
      closeIOModal: r,
      genericTaggingEvent: s
    }
  ) }) : /* @__PURE__ */ B("div", { className: "coupons-container", children: [
    (!o || o && u === "coupons-view") && /* @__PURE__ */ t(
      H,
      {
        orderFormId: h,
        hasItemsInCart: i,
        account: a,
        isIO: o,
        closeIOModal: r,
        coupons: q,
        firstCouponName: d,
        secondCouponName: m,
        replaceCoupon: y,
        setView: c,
        setFirstCouponName: v,
        setSecondCouponName: R,
        setActiveRule: C,
        setDataItem: k,
        setReplaceCoupon: N,
        setIsCloseModalEmpty: V,
        genericTaggingEvent: s
      }
    ),
    (!o || o && u === "rules-view") && D && /* @__PURE__ */ t(
      K,
      {
        dataItem: b,
        setActiveRule: C,
        setView: c,
        isIO: o,
        closeIOModal: r,
        genericTaggingEvent: s
      }
    ),
    (!o || o && u === "overwrite-view") && m && !y && /* @__PURE__ */ t(
      P,
      {
        firstCouponName: d,
        secondCouponName: m,
        setView: c,
        setReplaceCoupon: N,
        setSecondCouponName: R,
        isIO: o,
        closeIOModal: r,
        genericTaggingEvent: s
      }
    ),
    !i && J && /* @__PURE__ */ t(
      Q,
      {
        setIsCloseModalEmpty: V,
        genericTaggingEvent: s
      }
    )
  ] });
};
export {
  I as Coupons
};
